import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Row, Col, Button, Select, Modal, message } from 'antd';
import { FileAddOutlined, DeleteOutlined } from '@ant-design/icons';
import { find, isEmpty } from 'lodash';
import dayjs from 'dayjs';

import {
    loadReleaseNotes, deleteReleaseNote
} from '../actions';
import * as constants from '../constants';
import EditReleaseNote from './EditReleaseNote';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';


const Option = Select.Option;
const { AgGridWithState } = core;

const dateFormatter = (params) => {
    if (params.value) {
        return dayjs(params.value).format('DD-MM-YYYY');
    } else {
        return '';
    }
}

class ReleaseNotesGrid extends Component {

    state = {
        lang: 1043,
        releasenotes: [],
        currentEditEntity: {},
        addFormVisible: false,
        editFormVisible: false,
    }
    
    constructor(props) {
        super(props);

        this.gird = null;
        this.setGridRef = element => {
            this.gird = element;
        };
        this.deselectAll = () => {
            // Focus the text input using the raw DOM API
            if (this.gird) this.gird.deselectAll();
        };
    }

    async UNSAFE_componentWillMount() {
        let resp = await this.props.loadReleaseNotes(this.state.lang);
        this.setState({ releasenotes: resp.data });
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ReleaseNotesGrid', key);
    }

    refreshClicked = async () => {
        let resp = await this.props.loadReleaseNotes(this.state.lang);
        this.setState({ releasenotes: resp.data, currentEditEntity: {} });
        this.deselectAll();
    }

    getGridCols = () => {
        let cols = [
            { key: "createdOn", headerName: this.label("CreatedOn"), field: "createdOn", sortable: true, filter: true, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", valueFormatter: dateFormatter },
            { key: "title", headerName: this.label("Title"), field: "title", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "languageCode", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("LanguageCode"), field: "languageCode", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
        ]

        return cols;
    }

    handleChangeLanguage = async (value) => {
        const resp = await this.props.loadReleaseNotes(value);
        this.setState({
            releasenotes: resp.data,
            lang: parseInt(value)
        })
    }

    onCreateNewReleaseNoteClicked = () => {
        this.setState({
            currentEditEntity: { idReleaseNote: 0, languageId: this.state.lang, createdOn: new Date() },
            addFormVisible: true,
        });
    }
    onDeleteReleaseNoteClicked = async () => {
        if (!isEmpty(this.state.currentEditEntity)) {
            await this.props.deleteReleaseNote(this.state.currentEditEntity.idReleaseNote)
            this.setState({
                currentEditEntity: {},
            });
            this.refreshClicked();
        } else {
            message.warn(this.label("NoSelection"))
        }
    }
    onSelect = (dataitem) => {
        const editentity = find(this.state.releasenotes, { 'idReleaseNote': dataitem.idReleaseNote });
        this.setState({
            currentEditEntity: editentity,
        });
    }
    onDoubleClick = (dataitem) => {
        const editentity = find(this.state.releasenotes, { 'idReleaseNote': dataitem.idReleaseNote });
        this.setState({
            currentEditEntity: editentity,
            editFormVisible: true,
        });
    }

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
        });
        this.refreshClicked();
    }

    render() {
        const loading = this.props.loadingProjects;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='releasenotes'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify='start' align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("ReleaseNotes")}</span>
                        <Select showSearch optionFilterProp="children" filterOption={true} style={{ width: 100, marginLeft: 20 }}
                            placeholder='Select language / selecteer taal'
                            onChange={value => this.handleChangeLanguage(value)}
                            value={this.state.lang}
                        >
                            <Option key="1033" value={1033}>EN</Option>
                            <Option key="1043" value={1043}>NL</Option>
                        </Select>
                        <Button type="primary" icon={<FileAddOutlined />} onClick={this.onCreateNewReleaseNoteClicked} style={{ margin: 5, marginLeft: 25 }} >{this.label("NewReleaseNote")}</Button>
                        <Button icon={<DeleteOutlined />} onClick={this.onDeleteReleaseNoteClicked} style={{ margin: 5 }} >{this.label("DeleteReleaseNote")}</Button>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState ref={this.setGridRef} height={gridHeight} ShowGroupPanel={true}
                            lang={this.props.curLanguage}
                            onItemSelected={this.onSelect}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.state.releasenotes}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                        >
                        </AgGridWithState>
                    </>
                )}

                <Modal title={this.label("EditModalTitleForm")} width='80%' destroyOnHidden={true}
                    open={this.state.editFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <EditReleaseNote lang={this.state.lang} resource={this.state.currentEditEntity} onCancel={this.handleCancelForm} />
                </Modal>
                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true}
                    open={this.state.addFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <EditReleaseNote lang={this.state.lang} resource={this.state.currentEditEntity} onCancel={this.handleCancelForm} />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
    };
}

export default connect(mapStateToProps,
    {
        loadReleaseNotes, deleteReleaseNote
    })(ReleaseNotesGrid);